export const SERVER_API_URL = '';

export const LANG_KEY_EN = 'en';
